import React from 'react';

import { Outlet, useParams } from 'react-router-dom';

import { EmojiIDNotFoundOverlay, YatDashboardMobileShareModal } from '@pkg/components';
import { Navigation } from '@pkg/components/Navigation';
import { useAppSelector, useModal } from '@pkg/hooks';

import { YatPageVersion } from '@app/client';
import YatPage from '@app/pages/YatPage';

import { PageNotFound } from '../PageNotFound';
import { FreeYatModal } from '../Profile/FreeYatModal';

import { ProfileHeader } from './components/ProfileHeader';
import { ProfileNav } from './components/ProfileNav';
import { PROFILE_PAGE_WRAPPER_ID } from './constants';
import LiquidIDSection from './sections/LiquidIDSection';

import { ContentWrapper, PageWrapper } from './ProfilePage.style';

interface Props {
    isNotFound: boolean;
    isValidEmojiId?: boolean | null;
    pageVersion: YatPageVersion | null;
    eid?: string;
    isLoading: boolean;
}

export function ProfilePage({ isNotFound, pageVersion, isValidEmojiId, eid, isLoading }: Props) {
    const liquidIDExpandedPreview = useAppSelector((state) => state.yatPage.liquidIDExpandedPreview);
    const { yatParam } = useParams();
    const { isShowing: showFreeYat, toggle: toggleFreeYat } = useModal(false);

    if (!isValidEmojiId && !isLoading) {
        return <PageNotFound />;
    }

    if (!eid || !pageVersion || (yatParam && eid !== yatParam))
        return <>{isLoading ? <Navigation hideBackground></Navigation> : <PageNotFound />}</>;

    if (isNotFound) {
        return <EmojiIDNotFoundOverlay emojiId={eid} />;
    }

    if (pageVersion === YatPageVersion.V1) {
        return <YatPage />;
    }

    return (
        <>
            <Navigation hideBackground>
                <PageWrapper id={PROFILE_PAGE_WRAPPER_ID}>
                    {liquidIDExpandedPreview ? (
                        <LiquidIDSection />
                    ) : (
                        <>
                            <ProfileHeader />
                            <ProfileNav />
                            <ContentWrapper>
                                <Outlet />
                            </ContentWrapper>
                        </>
                    )}
                </PageWrapper>
            </Navigation>

            <FreeYatModal onClose={toggleFreeYat} isOpen={showFreeYat} />
            <YatDashboardMobileShareModal yat={eid || undefined} />
        </>
    );
}
